import contentRequest from '~/src/api/requests/contentRequest';

export const getTags = async() => {
    const res = await contentRequest.getWithCache('/v1/tags');

    return await res.data;
};
